export const mapShade = ({
  colorHexCode,
  colorImageUrl,
  productCode
}) => {
  const props = {
    productCode: productCode ?? ''
  };
  if (colorHexCode) {
    props.hexColors = colorHexCode.split(',');
  }
  if (colorImageUrl) {
    props.imageUrl = colorImageUrl;
  }
  return props;
};
//# sourceMappingURL=mapShade.js.map